// extracted by mini-css-extract-plugin
export default {"list":"HorizontalList_list__GESs0"};